export var PermissionType;
(function (PermissionType) {
    PermissionType["PermissionIdUnspecified"] = "permission_id_unspecified";
    PermissionType["GlobalSettingsView"] = "global_settings.view";
    PermissionType["VaultAccountsManage"] = "vault_accounts.manage";
    PermissionType["CostExplorerView"] = "cost_explorer.view";
    PermissionType["UserAccessManage"] = "user_access.manage";
    PermissionType["SamlGroupAccessManage"] = "saml_group_access.manage";
    PermissionType["ApiCredentialsManage"] = "api_credentials.manage";
    PermissionType["ApiCredentialsRotateSecret"] = "api_credentials.rotate_secret";
    PermissionType["CustomRolesManage"] = "custom_roles.manage";
    PermissionType["DashboardView"] = "dashboard.view";
    PermissionType["InventoryView"] = "inventory.view";
    PermissionType["JobsView"] = "jobs.view";
    PermissionType["AuditLogsView"] = "audit_logs.view";
    PermissionType["BackupSettingsView"] = "backup_settings.view";
    PermissionType["StorageGatewayView"] = "storage_gateway.view";
    PermissionType["DatabaseExplorerSearch"] = "database_explorer.search";
    PermissionType["FileExplorerSearch"] = "file_explorer.search";
    PermissionType["SnapshotsTakeOrConvert"] = "snapshots.take_or_convert";
    PermissionType["ResourcesRestore"] = "resources.restore";
    PermissionType["ConfigurationValidate"] = "configuration.validate";
    PermissionType["FilesRestore"] = "files.restore";
    PermissionType["DatabasesQuery"] = "databases.query";
    PermissionType["DataClassesOverride"] = "data_classes.override";
    PermissionType["EnvironmentsOverride"] = "environments.override";
    PermissionType["DetectedAppsOverride"] = "detected_apps.override";
    PermissionType["SensitivityLevelOverride"] = "sensitivity_level.override";
    PermissionType["NetworkClassificationOverride"] = "network_classification.override";
    PermissionType["ControlViolationsMute"] = "control_violations.mute";
    PermissionType["BackupExclusionManage"] = "backup_exclusion.manage";
    PermissionType["VaultsManage"] = "vaults.manage";
    PermissionType["SourceAccountsManage"] = "source_accounts.manage";
    PermissionType["RestoreAccountsManage"] = "restore_accounts.manage";
    PermissionType["BackupPoliciesManage"] = "backup_policies.manage";
    PermissionType["DiscoveryConfigurationManage"] = "discovery_configuration.manage";
    PermissionType["BackupConfigurationManage"] = "backup_configuration.manage";
    PermissionType["ControlsManage"] = "controls.manage";
    PermissionType["RansomwareDetectionManage"] = "ransomware_detection.manage";
    PermissionType["NotificationPoliciesManage"] = "notification_policies.manage";
    PermissionType["StorageGatewayManage"] = "storage_gateway.manage";
    PermissionType["OauthAppsManage"] = "oauth_apps.manage";
    PermissionType["ZeroEtlPoliciesManage"] = "zero_etl_policies.manage";
    PermissionType["ActionApprovalRulesManage"] = "action_approval_rules.manage";
    PermissionType["ActionApprovalRulesView"] = "action_approval_rules.view";
    PermissionType["ActionApprovalRequestsManage"] = "action_approval_requests.manage";
    PermissionType["MpaPoliciesManage"] = "mpa_policies.manage";
    PermissionType["MpaPoliciesView"] = "mpa_policies.view";
    PermissionType["MpaRequestsManage"] = "mpa_requests.manage";
    PermissionType["RestoreTemplatesManage"] = "restore_templates.manage";
    PermissionType["DatalakeView"] = "datalake.view";
    PermissionType["DatalakeOperate"] = "datalake.operate";
    PermissionType["ComplianceView"] = "compliance.view";
    PermissionType["ClassificationPoliciesManage"] = "classification_policies.manage";
    PermissionType["FileExplorerDelete"] = "file_explorer.delete";
    PermissionType["StorageGatewayDataDownload"] = "storage_gateway_data.download";
    PermissionType["StorageGatewayMetadataView"] = "storage_gateway_metadata.view";
    PermissionType["DataCatalogView"] = "data_catalog.view";
    PermissionType["DiscoveryTrigger"] = "discovery.trigger";
    PermissionType["DataCatalogQuery"] = "data_catalog.query";
    PermissionType["SaasBackupScopeManage"] = "saas_backup_scope.manage";
    PermissionType["SaasMailSearch"] = "saas_mail.search";
    PermissionType["SaasUserDriveSearch"] = "saas_user_drive.search";
    PermissionType["SaasGroupDataSearch"] = "saas_group_data.search";
    PermissionType["SaasSharedDriveSearch"] = "saas_shared_drive.search";
    PermissionType["SaasMailRestore"] = "saas_mail.restore";
    PermissionType["SaasUserDriveRestore"] = "saas_user_drive.restore";
    PermissionType["SaasGroupRestore"] = "saas_group.restore";
    PermissionType["SaasSharedDriveRestore"] = "saas_shared_drive.restore";
    PermissionType["SaasInventoryView"] = "saas_inventory.view";
    PermissionType["SaasJobsView"] = "saas_jobs.view";
    PermissionType["SaasSnapshotsTake"] = "saas_snapshots.take";
    PermissionType["SaasConfigurationValidate"] = "saas_configuration.validate";
    PermissionType["SaasUserSearch"] = "saas_user.search";
    PermissionType["SaasUserRestore"] = "saas_user.restore";
    PermissionType["ThreatDetectionCenterView"] = "threat_detection_center.view";
    PermissionType["ThreatDetectionExclusionManage"] = "threat_detection_exclusion.manage";
    PermissionType["SaasDashboardView"] = "saas_dashboard.view";
    PermissionType["SaasDiscoveryTrigger"] = "saas_discovery.trigger";
    PermissionType["SaasSourceAccountsManage"] = "saas_source_accounts.manage";
    PermissionType["SourceAccountsView"] = "source_accounts.view";
    PermissionType["SaasSourceAccountsView"] = "saas_source_accounts.view";
    PermissionType["RestoreAccountsView"] = "restore_accounts.view";
    PermissionType["DiscoveryConfigurationView"] = "discovery_configuration.view";
    PermissionType["VaultsView"] = "vaults.view";
    PermissionType["BackupPoliciesView"] = "backup_policies.view";
    PermissionType["SaasBackupPoliciesView"] = "saas_backup_policies.view";
    PermissionType["ClassificationPoliciesView"] = "classification_policies.view";
    PermissionType["ObjectFiltersView"] = "object_filters.view";
    PermissionType["BackupConfigurationView"] = "backup_configuration.view";
    PermissionType["ZeroEtlPoliciesView"] = "zero_etl_policies.view";
    PermissionType["RestoreTemplatesView"] = "restore_templates.view";
    PermissionType["SaasBackupPoliciesManage"] = "saas_backup_policies.manage";
    PermissionType["DataCatalogPermissionsManage"] = "data_catalog_permissions.manage";
    PermissionType["DataCatalogTagsManage"] = "data_catalog_tags.manage";
    PermissionType["DashboardManage"] = "dashboard.manage";
    PermissionType["AiAssistantUse"] = "ai_assistant.use";
})(PermissionType || (PermissionType = {}));
